export default "__VITE_ASSET__DXefSa0Y__"